module.exports = __webpack_public_path__ + "static/img/0644d9bb591386ca83b3e95e48f3cfa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品与服务-改(1)_03.png
// module id = TfFL
// module chunks = 1